function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../types.d.ts" />
import classnames from 'classnames';
import React from 'react';
import { DataGrid, Pagination, LoadingSlugs, SearchBar, Card, SelectList } from '@codametrix/ui-components';
import { DatePicker } from '../../components/date-picker/datepicker';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { defaultSortableOption } from '../../core/pageable-options';
import { defaultCriteriaFilter } from '../../core/criteria-filter';
import '../../styles/grid-common.scss';
import '../../styles/cmx.scss';
import './pageable-list.scss';
import { PopUpFiltersV2 } from '../pop-up-filter/pop-up-filtersV2';
import { AmplifyCore, commonEnums as enums } from '@codametrix/ui-common';
import { LOAD_STATES } from '../../reducers/common';
import classNames from 'classnames';
const { buildSortableWithFilters } = AmplifyCore.paginationUtils;
const { FilterTypes } = enums;
const pageSizeOptions = [
    {
        label: '25',
        value: 25
    },
    {
        label: '50',
        value: 50
    },
    {
        label: '100',
        value: 100
    },
    {
        label: '200',
        value: 200
    }
];
export const dummy = ()=>{
    return DatePicker;
};
var _React_Component;
class PageableList extends (_React_Component = React.Component) {
    componentDidUpdate(prevProps) {
        if (prevProps.columnDefs !== this.props.columnDefs) {
            this.setState({
                sortColumnDefs: null
            });
        }
    }
    componentDidMount() {
        const url = new URL(document.location.toString());
        if (!url.searchParams.has('back')) {
            this.props.list({
                ...this.props.sortablePageable
            });
        } else {
            this.props.onNavigate();
        }
    }
    _handleSearch(event) {
        const { detail: { value: { value, key } } } = event;
        let filters = [];
        filters = this.props.criteriaFilter.filters.filter((filter)=>{
            return filter.type === FilterTypes.IN;
        });
        const SearchFormMatch = this.props.criteriaFilter.searchForms.find((filter)=>{
            return filter.key === key;
        });
        //Skip Empty Searches
        //Ensure we have a matching search form
        //Ensure value from the custom event is a string
        if (value !== '' && SearchFormMatch && (typeof value === 'string' || value instanceof String)) {
            let newFilter = {
                key: key,
                terms: [
                    value.trim()
                ],
                type: SearchFormMatch.type
            };
            filters.push(newFilter);
        }
        this.props.list(buildSortableWithFilters(this.props.sortablePageable, {
            filters,
            dateFilter: undefined
        }));
    }
    _handleFilterRemove(event) {
        event.preventDefault();
        const target = event.target;
        const parentChip = target?.closest('.chip');
        const chipClose = target?.closest('.chip-close');
        if (parentChip === null || chipClose === null) {
            return;
        }
        const filterKey = parentChip.getAttribute('id');
        const currentTerm = chipClose.getAttribute('id');
        const currentFilter = this.props.criteriaFilter.filters.find((filter)=>{
            return filter.key === filterKey;
        });
        if (!currentFilter) {
            return;
        }
        const dateFilter = this.props.sortablePageable.filterableOptions?.dateFilter;
        let nextFilters;
        if (currentFilter.terms.length === 1) {
            nextFilters = this.props.criteriaFilter.filters.filter((filter)=>{
                return filter.key !== filterKey;
            });
        } else {
            nextFilters = this.props.criteriaFilter.filters.map((filter)=>{
                if (filter.key !== filterKey) {
                    return filter;
                }
                const newTerms = filter.terms.filter((term)=>term !== currentTerm);
                return {
                    ...filter,
                    terms: newTerms
                };
            });
        }
        this.props.list(buildSortableWithFilters(this.props.sortablePageable, {
            filters: nextFilters,
            dateFilter
        }));
    }
    render() {
        const { props } = this;
        const { loadState, filterLoadStates, items, columnDefs, onSelection, itemName, sortablePageable, criteriaFilter, idField, children, criteriaLoadState, onAction } = props;
        const displayColumnDefs = this.state.sortColumnDefs ?? columnDefs;
        const searchForms = criteriaFilter.searchForms.map((filterForm)=>{
            const isActiveSearch = criteriaFilter.filters.some((filter)=>{
                return filter.key === filterForm.key;
            });
            return {
                ...filterForm,
                isSelected: isActiveSearch
            };
        });
        const inFlight = loadState.loading || loadState.initial;
        const classes = [
            'pageable-list-view',
            'layout-full',
            {
                'request-in-flight': inFlight
            }
        ];
        const itemCountClasses = [
            {
                'request-in-flight': inFlight
            },
            'showing',
            'qa-item-count'
        ];
        const { pageableDefinition: pageable } = sortablePageable;
        const offsetInfo = pageable.pageable;
        let offset;
        if (pageable.totalElements) {
            offset = {
                start: offsetInfo.offset + 1,
                end: Math.min(offsetInfo.offset + offsetInfo.pageSize, pageable.totalElements)
            };
        } else {
            offset = {
                start: 0,
                end: 0
            };
        }
        const onPaginationClick = (action)=>{
            if (!inFlight) {
                const { sortablePageable: { pageableDefinition: pageable, sortableOptions, filterableOptions } } = this.props;
                const retAction = {
                    pageableDefinition: {
                        ...pageable,
                        pageable: {
                            ...pageable.pageable,
                            pageNumber: action.index,
                            pageSize: action.size
                        }
                    },
                    sortableOptions,
                    filterableOptions
                };
                this.props.list(retAction);
            }
        };
        const _handlePageResize = (event)=>{
            const pageAction = {
                index: 0,
                size: event.detail.value
            };
            onPaginationClick(pageAction);
        };
        const onSortClick = (action)=>{
            if (!inFlight) {
                const { sortablePageable: { pageableDefinition: pageable, sortableOptions, filterableOptions }, columnDefs: defsFromProps } = this.props;
                const sortableKeys = defsFromProps.find((def)=>def.key === action.key)?.sortableKeys ?? [];
                let nextSortableOptions = sortableOptions.map((o)=>({
                        ...o
                    }));
                sortableKeys.forEach((sortableKey)=>{
                    const match = nextSortableOptions.find((option)=>option.sortField === sortableKey);
                    if (match !== undefined) {
                        if (action.direction === 'none') {
                            nextSortableOptions = nextSortableOptions.filter((option)=>option.sortField !== match.sortField);
                        } else if (action.direction === 'asc' || action.direction === 'desc') {
                            nextSortableOptions = nextSortableOptions.map((option)=>option.sortField === match.sortField ? {
                                    ...option,
                                    sortDirection: action.direction
                                } : option);
                        }
                    } else if (action.direction === 'asc' || action.direction === 'desc') {
                        nextSortableOptions = [
                            ...nextSortableOptions,
                            {
                                sortField: sortableKey,
                                sortDirection: action.direction
                            }
                        ];
                    }
                });
                const colIndex = defsFromProps.findIndex((column)=>column.key === action.key);
                const nextColumnDefs = defsFromProps.map((col, i)=>i === colIndex ? {
                        ...col,
                        defaultSort: action.direction
                    } : col);
                this.setState({
                    sortColumnDefs: nextColumnDefs
                });
                const retAction = {
                    pageableDefinition: {
                        ...pageable
                    },
                    sortableOptions: nextSortableOptions,
                    filterableOptions
                };
                this.props.list(retAction);
            }
        };
        const inner = loadState.initial ? /*#__PURE__*/ _jsx(Card, {
            className: "loading-card",
            "data-testid": "loading-slugs",
            children: /*#__PURE__*/ _jsx(LoadingSlugs, {
                numberItems: 3
            })
        }) : items.length ? /*#__PURE__*/ _jsx(DataGrid, {
            onRowSelection: onSelection,
            onSortSelection: onSortClick,
            columnDefs: displayColumnDefs,
            items: items,
            idField: idField || 'id',
            onAction: onAction,
            "data-testid": "data-grid"
        }) : /*#__PURE__*/ _jsxs("h4", {
            className: "content-vacant qa-content-vacant",
            "data-testid": "content-vacant",
            children: [
                ' ',
                "No ",
                itemName,
                " found"
            ]
        });
        var defaultInput = sortablePageable.filterableOptions.filters?.find((filter)=>{
            return criteriaFilter.searchForms.find((form)=>filter.key === form.key);
        })?.terms[0];
        return /*#__PURE__*/ _jsxs("div", {
            className: classnames(classes),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "container heading-row layout-inner-header",
                    children: criteriaFilter.searchForms.length || criteriaFilter.filterForms.length ? /*#__PURE__*/ _jsx(Card, {
                        className: 'header-card',
                        children: criteriaLoadState === LOAD_STATES.done ? /*#__PURE__*/ _jsxs("span", {
                            children: [
                                criteriaFilter.searchForms?.length ? /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx("div", {
                                        children: /*#__PURE__*/ _jsx(SearchBar, {
                                            FieldDefinitions: searchForms,
                                            placeholder: 'Search',
                                            defaultInput: defaultInput,
                                            onSubmit: this._handleSearch
                                        })
                                    })
                                }) : false,
                                criteriaFilter.filterForms?.length ? /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "divider"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            children: /*#__PURE__*/ _jsx(PopUpFiltersV2, {
                                                criteriaFilter: criteriaFilter,
                                                loadStates: filterLoadStates,
                                                sortablePageable: this.props.sortablePageable,
                                                list: this.props.list,
                                                getDictionary: this.props.getDictionary,
                                                getStatuses: this.props.getStatuses,
                                                getTenants: this.props.getTenants,
                                                clearFilters: this.props.clearFilters,
                                                activeOrgId: this.props.activeOrgId
                                            })
                                        })
                                    ]
                                }) : false
                            ]
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "criteria-loading qa-criteria-loading",
                            children: /*#__PURE__*/ _jsx(LoadingSlugs, {
                                numberItems: 1
                            })
                        })
                    }) : false
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "pageable-gutter",
                    children: [
                        /*#__PURE__*/ _jsxs("span", {
                            className: classNames(itemCountClasses),
                            "data-testid": "item-count",
                            children: [
                                offset.start,
                                "–",
                                offset.end,
                                ' ',
                                /*#__PURE__*/ _jsx("span", {
                                    style: {
                                        fontSize: 12
                                    },
                                    children: "OF "
                                }),
                                pageable.totalElements,
                                ' ',
                                /*#__PURE__*/ _jsx("span", {
                                    style: {
                                        fontSize: 12
                                    },
                                    children: itemName.toUpperCase()
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: 'page-size-select',
                                    style: {
                                        fontSize: 12
                                    },
                                    children: "Items Per Page"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: 'qa-page-size-select-list',
                                    children: /*#__PURE__*/ _jsx(SelectList, {
                                        name: 'Page Size',
                                        options: pageSizeOptions,
                                        value: pageable.size.toString(),
                                        onChange: _handlePageResize
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: 'm-2',
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "layout-inner-body pageable-list-inner-body ",
                    children: [
                        /*#__PURE__*/ _jsx(SwitchTransition, {
                            mode: 'out-in',
                            children: /*#__PURE__*/ _jsx(CSSTransition, {
                                classNames: "switch-views",
                                timeout: 150,
                                children: inner
                            }, loadState.loading ? 'list-loading' : 'list-loaded')
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "pagination-controls",
                            children: /*#__PURE__*/ _jsx(Pagination, {
                                pageable: pageable,
                                onSelect: onPaginationClick
                            })
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            filterFormOpen: false,
            selectedForm: undefined,
            sortColumnDefs: null
        };
        this._handleFilterRemove = this._handleFilterRemove.bind(this);
        this._handleSearch = this._handleSearch.bind(this);
    }
}
_define_property(PageableList, "defaultProps", {
    list: (options)=>{},
    onNavigate: ()=>{},
    getDictionary: (dictionaryName)=>{},
    getStatuses: (dictionaryName)=>{},
    onAction: (content)=>{},
    clearAllFilters: ()=>{},
    pageableOptions: defaultSortableOption,
    criteriaFilter: defaultCriteriaFilter,
    criteriaLoadState: LOAD_STATES.done
});
export default PageableList;
